import React from 'react';
import HeroSection from './HeroSection/HeroSection';
import ReviewSection from './ReviewSection/ReviewSection';
import KeyBenefitsSection from './KeyBenefitsSection/KeyBenefitsSection';
import NfcEnabled from './NfcEnabled/NfcEnabled';

const Home = () => {
    return (
        <div className="gap-8 flex flex-col items-center pb-12">
            <HeroSection />
            <ReviewSection />
            <KeyBenefitsSection />
            <NfcEnabled />
        </div>
    );
};

export default Home;
